import xlsx from 'json-as-xlsx';
import moment from 'moment';
import insertIf from '../../../../utils/insertIf';
import LABELS_WHISP from '../../../../constants/LabelsWhisp';

const LotesExport = (data, ciclo, estados, coopConfig) => {
  const usa_eudr = !!+coopConfig.config?.usa_eudr;
  const usa_calidad = !!+coopConfig.config?.usa_calidad;
  let xlsData = [
    {
      sheet: 'Lotes',
      columns: [
        { label: 'NOMBRE', value: 'nombre' },
        { label: 'CÓDIGO', value: 'folio' },
        ...insertIf(!coopConfig.hasAcopioUnitsExtra(), {
          label: `VOLUMEN TOTAL (${coopConfig.acopioUnits()?.abreviacion})`,
          value: row => {
            if (Number(row.volumen) > 0) {
              return Number(row.volumen);
            }
            return 0;
          },
          format: '0.00',
        }),
        ...insertIf(coopConfig.hasAcopioUnitsExtra(), {
          label: `VOLUMEN TOTAL (${coopConfig.acopioUnitsExtra()?.abreviacion})`,
          value: row => {
            if (Number(row.volumen_extra) > 0) {
              return Number(row.volumen_extra);
            }
            return 0;
          },
          format: '0.00',
        }),
        ...insertIf(!coopConfig.hasAcopioUnitsExtra(), {
          label: `VOLUMEN POR ENTREGAR (${coopConfig.acopioUnits()?.abreviacion})`,
          value: row => {
            if (Number(row.lote_kgs_por_entregar) > 0) {
              return Number(row.lote_kgs_por_entregar);
            }
            return 0;
          },
          format: '0.00',
        }),
        ...insertIf(coopConfig.hasAcopioUnitsExtra(), {
          label: `VOLUMEN POR ENTREGAR (${coopConfig.acopioUnitsExtra()?.abreviacion})`,
          value: row => {
            if (Number(row.lote_kgs_por_entregar_extra) && Number(row.lote_kgs_por_entregar_extra) !== 0) {
              return Number(row.lote_kgs_por_entregar_extra);
            }
            return 0;
          },
          format: '0.00',
        }),
        ...insertIf(!coopConfig.hasAcopioUnitsExtra(), {
          label: `VOLUMEN ASIGNADO (${coopConfig.acopioUnits()?.abreviacion})`,
          value: row => {
            if (Number(row.lote_kgs_entregados) > 0) {
              return Number(row.lote_kgs_entregados);
            }
            return 0;
          },
          format: '0.00',
        }),
        ...insertIf(coopConfig.hasAcopioUnitsExtra(), {
          label: `VOLUMEN ASIGNADO (${coopConfig.acopioUnitsExtra()?.abreviacion})`,
          value: row => {
            if (Number(row.lote_kgs_entregados_extra) > 0) {
              return Number(row.lote_kgs_entregados_extra);
            }
            return 0;
          },
          format: '0.00',
        }),
        {
          label: 'AVANCE ACOPIO  ',
          value: row => {
            if (Number(row.volumen) > 0) {
              const avance = Number(row.lote_kgs_entregados) / Number(row.volumen);
              return Number(avance.toFixed(4));
            }
            return 0;
          },
          format: '0.00%',
        },
        { label: 'ESTADO', value: row => estados.find(it => it.value == row.id_recoleccion_acopio_estatus).label },
        { label: 'OBSERVACIONES', value: 'observaciones' },
        { label: 'FECHA DE ENTREGA O VENTA', value: 'fecha_entrega_venta' },
        ...insertIf(usa_eudr, { label: 'RIESGO EUDR', value: row => LABELS_WHISP[row.riesgo_eudr] ?? '-' }),
        ...insertIf(usa_calidad, { label: 'ID MUESTRA', value: 'id_muestra' }),
        ...insertIf(usa_calidad, { label: 'TIPO DE MUESTRA', value: 'nombre_tipo_muestra' }),
        ...insertIf(usa_calidad, {
          label: 'RENDIMIENTO BRUTO (%)',
          value: row => {
            if (Number(row.rendimiento_bruto) > 0) {
              return Number(row.rendimiento_bruto);
            }
            return null;
          },
          format: '0.00',
        }),
        ...insertIf(usa_calidad, {
          label: 'RENDIMIENTO EXPORTABLE (%)',
          value: row => {
            if (Number(row.rendimiento_exportable_por) > 0) {
              return Number(row.rendimiento_exportable_por);
            }
            return null;
          },
          format: '0.00',
        }),
        ...insertIf(usa_calidad, {
          label: 'RENDIMIENTO REAL (%)',
          value: row => {
            if (Number(row.rendimiento_real) > 0) {
              return Number(row.rendimiento_real);
            }
            return null;
          },
          format: '0.00',
        }),
        ...insertIf(usa_calidad, {
          label: 'PUNTAJE EN TAZA',
          value: row => {
            if (Number(row.puntaje_manual) > 0) {
              return Number(row.puntaje_manual);
            }
            return null;
          },
          format: '0.00',
        }),
      ],
      content: data,
    },
  ];

  let settings = {
    fileName: `Lotes_${ciclo.id}_${moment().format('YYYYMMDD_HHmmss')}`,
  };
  xlsx(xlsData, settings);
};

export default LotesExport;
